import React from 'react';
function Heading2({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 4v16M3.5 12h8M12 4v16M16.5 14.5c0-1.5 1-2 2-2 1.5 0 2.5 1.5 1 3.5M19.5 16l-3 4M16.5 20h4"
      />
    </svg>
  );
}

export default Heading2;
